import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
  ChangeDetectorRef,
  ElementRef,
} from '@angular/core';
import { Questions } from 'src/app/common-class/questions';
import { Group, Matrix } from 'src/app/common-class/pages';
import { CommonLogic } from 'src/app/COMMON-LOGIC/common-logic';
import { ParticipationDataService } from 'src/app/_services/participation-data.service';
import { PreviewData } from 'src/app/common-class/survey';
import { SurveyMessages } from 'src/app/common-class/survey-messages';

@Component({
  selector: 'app-multiple-drop-down',
  templateUrl: './multiple-drop-down.component.html',
  styleUrls: ['./multiple-drop-down.component.css'],
})
export class MultipleDropDownComponent implements OnInit {
  @Input() JsonData: string;
  @Input() productTitle: string;
  @Input() isMandatoryUpfront: boolean;
  @Input() isDisplayQno: boolean;
  @Input() group: Group;
  @Input() matrix: Matrix;
  @Input() isMDD: boolean;
  @Input() isSubmitted: boolean;
  @Input() DropDown: string;
  @Input() isMobile: boolean;
  @Input() isNewParticipationButton: boolean;
  @Output() ChangeAnswersData: EventEmitter<Questions> = new EventEmitter<Questions>();

  questions: Questions[];
  imgQuestion: Questions;
  firstQuestion: Questions;

  tempArray = [];
  questionsArray: any;

  mainQuestionWidth: any;
  showLoader: boolean = false;
  subQuestionWidth: any;
  totalWidth: any;
  checkDrillDown: number = 0;
  prevValue: any;
  dropDownCount: number;
  dropDownlength: number;
  isNewParticipation: boolean;
  surveyFormat: number;
  newParticipationBtnText: string;
  showNewParticipationButton: boolean;
  isAnsChange: boolean = false;
  isSearchableDD: boolean = false;
  isPreReadQn: boolean;
  resetPageSub: any;
  isNgOnChange: boolean;
  ngCount: number = 0;
  isAnswerPipingSubChar: boolean;
  isDisplayedPipeMessage: boolean;
  MDDdropDownCount: number;
  Nomatchfound: string;
  surveyMessages: SurveyMessages;
  isAnySubQMandatory: boolean;
  isPreview: boolean;

  constructor(
    private service: ParticipationDataService,
    private previewData: PreviewData,
    private changeDetect: ChangeDetectorRef,
    private elementRef: ElementRef,
  ) {}

  // Helper method to get element by ID
  private getElement(id: string): HTMLElement | null {
    return document.getElementById(id);
  }

  // Helper method to get elements by class
  private getElementsByClass(className: string): Element[] {
    return Array.from(document.getElementsByClassName(className));
  }

  // Helper method to get closest parent element
  private getClosestParent(element: HTMLElement, selector: string): HTMLElement | null {
    return element.closest(selector);
  }

  ngOnChanges(changes: SimpleChanges) {
    let change = changes['JsonData'];
    if (change != undefined && change != null) {
      let curVal = JSON.stringify(change.currentValue);
      let preVal = JSON.stringify(change.previousValue);
      if (curVal != preVal && preVal != undefined) {
        this.objectLoading();
        if (this.questions.length > 0) {
          this.isNgOnChange = true;
          this.ngCount = 1;
          if (this.matrix.MultiColumnCount > 1) {
            this.HorizontalHandling();
          }
          if (!this.isMDD) {
            for (let i = 0; i < this.questions.length; i++) {
              if (this.questions[i].selectAnsValue == undefined) {
                this.questions[i].selectAnsValue = -1;
              }

              if (this.isAnswerPipingSubChar) {
                this.questions[i].subQnoinChar = CommonLogic.Convert_To_Alpha(i + 1);
              }

              if (this.questions[i].answer_style == 2) {
                this.questions[i].Answers = CommonLogic.RandomAnswerHandling(this.questions[i]);
              }
            }
            if (this.group.answer_style == 2) {
              this.questions = CommonLogic.RandomQuestionsHandling(this.questions);
            }
          }
          if (this.isMDD) {
            if (this.group.answer_style == 1 && this.isMDD) {
              this.questions = CommonLogic.RandomQuestionsHandling(this.questions);
            } else if (this.group.answer_style == 0 && this.questions.length > 1) {
              this.questions.sort((n1, n2) => n1.sub_qno - n2.sub_qno);
            } else if (
              this.group.answer_style == 2 &&
              this.questions[0].grpRotateIndex != -1 &&
              this.questions.length > 1
            ) {
              this.questions.sort((n1, n2) => n1.sub_qno - n2.sub_qno);
              CommonLogic.RotateQuestionsHandling(this.questions);
            }

            this.ngAfterViewInit();
          }
          this.questions = this.questions.filter((e) => !e.isHiddenQ);
        }
      }
    }
  }

  ngOnInit() {
    if (this.questions == null) {
      this.surveyMessages = this.service.getSurveyMessages();
      this.objectLoading();

      this.questions = this.questions?.filter((e) => !e.isHiddenQ);

      if (this.questions?.length > 0) {
        this.MDDdropDownCount = this.service.getMDDdropDownCount();
        this.Nomatchfound = this.service.getSurveyMessages()?.Participation_Nomatchfound;
        if (this.questions.filter((e) => e.Answers.length > this.MDDdropDownCount - 1).length > 0) {
          this.isSearchableDD = true;
        }
        if (this.group.answer_style == 1 && this.isMDD) {
          this.questions = CommonLogic.RandomQuestionsHandling(this.questions);
        } else if (this.group.answer_style == 0 && this.questions.length > 1) {
          this.questions.sort((n1, n2) => n1.sub_qno - n2.sub_qno);
        } else if (
          this.group.answer_style == 2 &&
          this.questions[0].grpRotateIndex != -1 &&
          this.questions.length > 1
        ) {
          this.questions.sort((n1, n2) => n1.sub_qno - n2.sub_qno);
          CommonLogic.RotateQuestionsHandling(this.questions);
        }

        if (this.matrix.MultiColumnCount > 1) {
          this.HorizontalHandling();
        }
        if (!this.isMDD) {
          for (let i = 0; i < this.questions.length; i++) {
            if (this.questions[i].selectAnsValue == undefined) {
              this.questions[i].selectAnsValue = -1;
            }

            if (this.isAnswerPipingSubChar) {
              this.questions[i].subQnoinChar = CommonLogic.Convert_To_Alpha(i + 1);
            }

            if (this.questions[i].answer_style == 2) {
              this.questions[i].Answers = CommonLogic.RandomAnswerHandling(this.questions[i]);
            }
          }

          if (this.group.answer_style == 2) {
            this.questions = CommonLogic.RandomQuestionsHandling(this.questions);
          }
        }

        if (
          this.questions.filter((e) => e.mandatory) != undefined &&
          this.questions.filter((e) => e.mandatory).length > 0
        ) {
          this.isAnySubQMandatory = true;
        }

        this.isNewParticipation = this.service.isNewParticipation;
        this.surveyFormat = this.service.surveyFormat;
        this.dropDownCount = this.service.getdropDownCount();
        this.MDDdropDownCount = this.service.getMDDdropDownCount();
        this.dropDownlength = this.questions.length;
        this.newParticipationBtnText = this.service.newParticipationBtnText;
        this.showNewParticipationButton =
          (this.questions.length > 1 || !this.service.isAutoScroll) &&
          this.isNewParticipationButton;
        this.isPreReadQn = this.questions.filter((e) => e.population_type == 3).length > 0;
      }
    }
    this.isPreview = this.service.GroupType?.toUpperCase() == 'PREVIEW';
  }

  objectLoading() {
    this.questions = JSON.parse(this.JsonData);

    let fstQn = this.questions?.[0];
    if (fstQn != undefined && fstQn != null) {
      this.firstQuestion = fstQn;
    }

    let imgQn = this.questions?.find((e) => e.sub_qno == 1);
    if (imgQn != undefined && imgQn != null) {
      this.imgQuestion = imgQn;
    }

    if (
      this.previewData != undefined &&
      this.previewData.isPrevPgChnge &&
      this.questions[0].AnsPipeCondition != 0 &&
      this.questions[0].AnsPipeCondition != 1 &&
      this.questions[0].AnsPipeCondition != 3 &&
      this.questions[0].AnsPipeCondition != 4 &&
      this.questions.find((e) => e.isMultiQuestionPiping) == undefined
    ) {
      this.isDisplayedPipeMessage = true;
    } else {
      this.isDisplayedPipeMessage = false;
    }

    if (this.questions?.find((e) => e.AnsPipeCondition > 1) != undefined && this.isDisplayQno) {
      this.isAnswerPipingSubChar = true;
    } else {
      this.isAnswerPipingSubChar = false;
    }

    this.questions = this.questions?.filter((e) => !e.isMultiQuestionPiping);
  }

  UpdateQuestionsData(question: Questions) {
    this.isAnsChange = true;
    this.ChangeAnswersData.emit(question);
  }

  HorizontalHandling() {
    let previewData = this.service.getPreviewData();
    let DispAnsCol = this.matrix.MultiColumnCount;
    let ansArray = [];

    let nonHiddenQs;
    if (previewData && previewData.isShowHiddenQN) {
      nonHiddenQs = [...this.questions];
    } else {
      nonHiddenQs = this.questions.filter(
        (e) =>
          (!e.isCQHide && e.population_type != 2 && e.population_type != 5) ||
          this.service.getisEditResponse(),
      );
    }

    let answerLength = nonHiddenQs.length;
    let rowCount = Math.ceil(answerLength / DispAnsCol);

    for (let i = 0; i < rowCount; i++) {
      let tempArray = [];
      let counter = 0;
      for (let j = i * DispAnsCol; j < answerLength; j++) {
        counter++;
        tempArray.push(nonHiddenQs[j]);

        if (counter == DispAnsCol) {
          break;
        }
      }

      ansArray.push(tempArray);
    }

    this.tempArray[0] = ansArray;
    this.questionsArray = this.tempArray;
  }

  GetQuestionsString(question): string {
    return JSON.stringify(question);
  }

  ngAfterViewInit() {
    if (window.navigator.userAgent.indexOf('Chrome') != -1) {
      const answerParents = document.getElementsByClassName('answerParent');
      Array.from(answerParents).forEach((parent) => {
        (parent as HTMLElement).style.width = 'calc(100% + 1px)';
      });
    }

    if (this.questions.length == 0) {
      return;
    }

    const self = this;
    if (self.isSearchableDD) {
      const elemid = `Q${self.firstQuestion.qno}_${self.firstQuestion.UniqueNumber}_RW`;
      const element = document.getElementById(elemid);
      if (element) {
        const answerWrapper = element.querySelector('.answer-option-wrapper');
        if (answerWrapper) {
          (answerWrapper as HTMLElement).style.paddingBottom = '70px';
          answerWrapper.classList.add('GridSearch');
        }
        const mainQuesCont = element.closest('.main-ques-cont');
        if (mainQuesCont) {
          mainQuesCont.classList.add('remove_spacer_mdd');
        }
      }
    }

    if (this.isMDD) {
      setTimeout(() => {
        const elemid = `Q${self.firstQuestion.qno}_${self.firstQuestion.UniqueNumber}_RW`;
        const element = document.getElementById(elemid);
        if (element) {
          const mddWrappers = element.querySelectorAll('.mdd-wrapper');
          mddWrappers.forEach((wrapper) => {
            const questionOptionWrapper = wrapper.querySelector('.question-option-wrapper');
            if (questionOptionWrapper) {
              questionOptionWrapper.classList.add('subqtn');
            }
          });

          if (element.querySelector('.mdd-wrapper.singleCol')) {
            setTimeout(() => {
              const questionOptionWrappers = element.querySelectorAll(
                '.mdd-wrapper.singleCol .question-option-wrapper.subqtn',
              );
              const widths: number[] = [];

              questionOptionWrappers.forEach((wrapper) => {
                const questionText = wrapper.querySelector('.question-text');
                if (questionText) {
                  (questionText as HTMLElement).style.whiteSpace = 'nowrap';
                }
                widths.push((wrapper as HTMLElement).getBoundingClientRect().width);
              });

              let max = Math.max(...widths);
              if (max > 350) max = 350;
              if (max < 25) max = 25;
              else max += 10;

              questionOptionWrappers.forEach((wrapper) => {
                (wrapper as HTMLElement).style.width = `${max}px`;
                (wrapper as HTMLElement).style.minWidth = `${max}px`;
              });

              const questionTexts = element.querySelectorAll(
                '.mdd-wrapper.singleCol .question-text',
              );
              questionTexts.forEach((text) => {
                (text as HTMLElement).style.whiteSpace = 'normal';
              });
            }, 50);
          } else {
            // Multiple columns width calculations
            const questionTexts = element.querySelectorAll('.question-text');
            questionTexts.forEach((text) => {
              (text as HTMLElement).style.whiteSpace = 'nowrap';
            });

            const columnStruct = element.querySelector('.column-struct-mdd');
            if (columnStruct) {
              const table = columnStruct.querySelector('table');
              if (table) {
                const rows = table.querySelectorAll('tr');
                const firstRowCells = rows[0].querySelectorAll('td');
                const colLen = firstRowCells.length;
                const rowLen = rows.length;

                let lengthArr = colLen === 2 ? [0, 0] : [0, 0, 0];
                let totallen = 0;

                for (let i = 0; i < colLen; i++) {
                  for (let j = 0; j < rowLen; j++) {
                    const cell = rows[j].querySelectorAll('td')[i];
                    if (cell) {
                      const wrapper = cell.querySelector('.question-option-wrapper.subqtn');
                      if (wrapper) {
                        const width = (wrapper as HTMLElement).getBoundingClientRect().width;
                        if (width > lengthArr[i]) {
                          lengthArr[i] = width;
                        }
                      }
                    }
                  }
                  if (lengthArr[i] > 450) {
                    lengthArr[i] = 450;
                  }
                }

                lengthArr.forEach((len) => {
                  totallen += len;
                });

                (table as HTMLElement).style.width = `${totallen}px`;

                for (let i = 0; i < rowLen; i++) {
                  const cells = rows[i].querySelectorAll('td');
                  for (let j = 0; j < colLen; j++) {
                    const cell = cells[j];
                    if (cell) {
                      const wrapper = cell.querySelector('.question-option-wrapper.subqtn');
                      if (wrapper) {
                        (wrapper as HTMLElement).style.width = `${lengthArr[j]}px`;
                        (wrapper as HTMLElement).style.minWidth = `${lengthArr[j]}px`;
                        (wrapper as HTMLElement).style.maxWidth = '450px';
                      }

                      const questionText = cell.querySelector(
                        '.question-option-wrapper.subqtn .question-text',
                      );
                      if (questionText) {
                        (questionText as HTMLElement).style.maxWidth = '430px';
                      }

                      const span = cell.querySelector(
                        '.question-option-wrapper.subqtn .question-text span',
                      );
                      if (span) {
                        (span as HTMLElement).style.display = 'inline-block';
                        (span as HTMLElement).style.verticalAlign = 'top';
                        (span as HTMLElement).style.maxWidth = '400px';
                      }
                    }
                  }
                }
              }
            }

            questionTexts.forEach((text) => {
              (text as HTMLElement).style.whiteSpace = 'normal';
            });
          }
        }
      }, 50);

      if (self.matrix.MultiColumnCount > 1) {
        setTimeout(() => {
          const elemid = `dv_${self.firstQuestion.UniqueNumber}`;
          const element = document.getElementById(elemid);
          if (element) {
            const answerWrapper = element.querySelector('.answer-option-wrapper');
            if (answerWrapper && (answerWrapper as HTMLElement).offsetWidth > element.offsetWidth) {
              const scrollBtn = element.querySelector('.div-scroll-btn');
              if (scrollBtn) {
                (scrollBtn as HTMLElement).style.display = 'block';
              }
            }
          }
        }, 0);

        document.addEventListener('DOMContentLoaded', () => {
          const elemid = `dv_${self.firstQuestion.UniqueNumber}`;
          const element = document.getElementById(elemid);
          if (element) {
            if (self.isSearchableDD) {
              const answerWrapper = element.querySelector('.answer-option-wrapper');
              if (answerWrapper) {
                (answerWrapper as HTMLElement).style.paddingBottom = '70px';
                answerWrapper.classList.add('GridSearch');
              }
              const mainQuesCont = element.closest('.main-ques-cont');
              if (mainQuesCont) {
                mainQuesCont.classList.add('remove_spacer_mdd');
              }
            }

            const fieldsetWrapper = element.querySelector('.fieldset-wrapper-scroll');
            if (fieldsetWrapper) {
              fieldsetWrapper.addEventListener('scroll', () => {
                const divScroll = fieldsetWrapper.closest('.divScroll');
                if (divScroll) {
                  const scrollBtn = divScroll.querySelector('.div-scroll-btn');
                  if (scrollBtn) {
                    if (document.querySelector('.RTLDir')) {
                      if (fieldsetWrapper.scrollLeft === 0) {
                        (scrollBtn as HTMLElement).style.display = 'none';
                      } else {
                        (scrollBtn as HTMLElement).style.display = 'block';
                      }
                    } else {
                      if (
                        (fieldsetWrapper as HTMLElement).offsetWidth - fieldsetWrapper.scrollLeft <=
                        (fieldsetWrapper as HTMLElement).offsetWidth + 5
                      ) {
                        (scrollBtn as HTMLElement).style.display = 'none';
                      } else {
                        (scrollBtn as HTMLElement).style.display = 'block';
                      }
                    }
                  }
                }
              });
            }
          }
        });
      }
    } else {
      this.setRddColWidth();
    }

    window.addEventListener('resize', () => {
      this.setRddColWidth();
    });

    document.addEventListener('DOMContentLoaded', () => {
      this.questions.forEach((question) => {
        const drillDownInput = document.querySelector(
          `input.drill-down-input-${question.UniqueNumber}`,
        );
        if (drillDownInput) {
          if ((drillDownInput as HTMLInputElement).value === '') {
            drillDownInput.classList.remove('no-search-icon');
          } else {
            drillDownInput.classList.add('no-search-icon');
          }
        } else {
          const regularInput = document.querySelector(
            `#dv_${question.UniqueNumber} input.drill-down-input`,
          );
          if (regularInput) {
            if ((regularInput as HTMLInputElement).value === '') {
              regularInput.classList.remove('no-search-icon');
            } else {
              regularInput.classList.add('no-search-icon');
            }
          }
        }
      });
    });

    this.resetPageSub = this.service.emitResetPageEvent.subscribe((data) => {
      if (data) {
        this.isAnsChange = false;
      }
    });

    if (this.questions != null) {
      if (this.questions.length > 0) {
        if (!this.isMDD) {
          this.questions.forEach((question) => {
            const messageElement = document.querySelector(
              `.drill-down-list-itemMessage_${question.UniqueNumber}`,
            );
            if (messageElement) {
              (messageElement as HTMLElement).style.display = 'none';
            }
            const container = document.getElementById(`dv_RDDG_${question.UniqueNumber}`);
            if (container) {
              const width = container.offsetWidth;
              if (messageElement) {
                (messageElement as HTMLElement).style.width = `${width}px`;
              }
            }
          });
        }
      }
    }
  }

  ngOnDestroy() {
    if (this.resetPageSub) {
      this.resetPageSub.unsubscribe();
    }
  }

  DropDownSelectedValue(
    event: any,
    question: Questions,
    isSearchableDD: boolean = false,
    curVal: number = -1,
  ) {
    let value = event.target.value;
    if (isSearchableDD) {
      value = curVal.toString();
    }

    if (value === '-1') {
      question.isOtherAnswer = false;
      question.selectAnsValue = -1;
      question.AnswerID = 0;
      question.AnswerText = null;
    } else {
      for (const answerItem of question.Answers) {
        if (value == answerItem.value_id) {
          event.selectdId = 1;
          answerItem.selectdId = 1;
          question.AnswerID = answerItem.ms_id;
          question.selectAnsValue = answerItem.value_id;
          question.AnswerText = answerItem.value_text;
          question.pageto = answerItem.pageto;
          question.otherAnswer = null;

          if (question.isSoftRequired) {
            question.isSoftRequiredHandle = true;
          }

          if (answerItem.isOther) {
            question.isOtherAnswer = true;
          } else {
            question.isOtherAnswer = false;
          }
        } else {
          answerItem.ControlAns = null;
          answerItem.selectdId = 0;
        }
      }
    }

    this.UpdateQuestionsData(question);
  }

  GetSubQnNumber(): boolean {
    return this.isDisplayQno;
  }

  getPipingTitle(group_no: number): string {
    return this.service.getPiping(group_no);
  }
  getHiddenQuestions(questions: Questions, service: ParticipationDataService) {
    if (
      service.getGroupType()?.toLowerCase() == 'preview' &&
      service.getPreviewData().isShowHiddenQN
    ) {
      return true;
    } else {
      return (
        (questions.population_type != 2 && questions.population_type != 5 && !questions.isCQHide) ||
        service.getisEditResponse()
      );
    }
  }

  closeDDList(event: Event) {
    const target = event.target as HTMLInputElement;
    if (target.value !== '') {
      target.value = '';
    }
    const drillSearch = target.closest('.drill-down-search');
    if (drillSearch) {
      drillSearch.classList.remove('showDrillList');
      target.setAttribute('aria-expanded', 'false');
    }
  }

  setDrillDownValue(event: Event, question: Questions, self: any, curVal: number) {
    self.DropDownSelectedValue(event, question, true, curVal);

    const drillDownInput = document.querySelector(
      `input.drill-down-input-${question.UniqueNumber}`,
    );
    if (drillDownInput) {
      if ((drillDownInput as HTMLInputElement).value === '') {
        drillDownInput.classList.remove('no-search-icon');
      } else {
        drillDownInput.classList.add('no-search-icon');
      }
    } else {
      const regularInput = document.querySelector(
        `#dv_${question.UniqueNumber} input.drill-down-input`,
      );
      if (regularInput) {
        if ((regularInput as HTMLInputElement).value === '') {
          regularInput.classList.remove('no-search-icon');
        } else {
          regularInput.classList.add('no-search-icon');
        }
      }
    }
  }

  selectDDListItem(event: MouseEvent, question: Questions) {
    const target = event.target as HTMLElement;
    const drillSearch = target.closest('.drill-down-search');
    if (drillSearch) {
      const drillInput = drillSearch.querySelector('.drill-down-input') as HTMLInputElement;
      if (drillInput) {
        drillInput.value = '';
      }

      const listItems = drillSearch.querySelectorAll('.drill-down-list-item');
      listItems.forEach((item) => {
        const originalValue = item.getAttribute('ogListValue');
        if (originalValue) {
          item.innerHTML = originalValue;
          (item as HTMLElement).style.display = 'block';
          item.innerHTML = this.highlight(item.innerHTML, '');
        }
      });

      const itemText = target.getAttribute('ogListValue');
      const itemValue = target.getAttribute('list-value');
      if (itemValue) {
        const select = drillSearch.querySelector('select') as HTMLSelectElement;
        if (select) {
          select.value = itemValue;
        }
        if (drillInput && itemText) {
          drillInput.value = itemText;
        }
      }

      drillSearch.classList.remove('showDrillList');
      const td = drillSearch.closest('td');
      if (td) {
        (td as HTMLElement).style.zIndex = '0';
      }

      this.checkDrillDown = 1;
      this.setDrillDownValue(event, question, this, parseInt(itemValue || '0'));
    }
  }

  showDDList(event: MouseEvent) {
    const target = event.target as HTMLElement;
    const drillSearch = target.closest('.drill-down-search');
    if (drillSearch) {
      if (drillSearch.classList.contains('showDrillList')) {
        drillSearch.classList.remove('showDrillList');
        const drillInput = drillSearch.querySelector('.drill-down-input');
        if (drillInput) {
          (drillInput as HTMLElement).setAttribute('aria-expanded', 'false');
        }
      } else {
        document.querySelectorAll('.drill-down-search').forEach((search) => {
          search.classList.remove('showDrillList');
        });
        drillSearch.classList.add('showDrillList');
        const drillInput = drillSearch.querySelector('.drill-down-input');
        if (drillInput) {
          (drillInput as HTMLElement).focus();
        }
        const listItems = drillSearch.querySelectorAll('.drill-down-list-item');
        listItems.forEach((item) => {
          (item as HTMLElement).style.display = 'block';
        });
        const td = drillSearch.closest('td');
        if (td) {
          (td as HTMLElement).style.zIndex = '2';
        }
      }
    }
  }

  setDDListItem(event: Event, question: Questions) {
    setTimeout(() => {
      if (this.checkDrillDown === 0 && this.checkDrillDown !== undefined) {
        const target = event.target as HTMLInputElement;
        const ddSearchValue = target.value.toLowerCase();
        if (ddSearchValue !== '') {
          const drillSearch = target.closest('.drill-down-search');
          if (drillSearch) {
            const listItems = drillSearch.querySelectorAll('.drill-down-list-item');
            listItems.forEach((item) => {
              const originalValue = item.getAttribute('ogListValue');
              if (originalValue) {
                item.innerHTML = originalValue;
                if (ddSearchValue === item.textContent?.toLowerCase()) {
                  target.value = originalValue;
                  const td = target.closest('td');
                  if (td) {
                    (td as HTMLElement).style.zIndex = '0';
                  }
                  const itemValue = item.getAttribute('list-value');
                  if (itemValue) {
                    const select = drillSearch.querySelector('select');
                    if (select) {
                      (select as HTMLSelectElement).value = itemValue;
                    }
                    this.setDrillDownValue(event, question, this, parseInt(itemValue));
                    return;
                  }
                } else {
                  target.value = '';
                  const select = drillSearch.querySelector('select');
                  if (select) {
                    (select as HTMLSelectElement).value = '0';
                  }
                  question.AnswerText = null;
                  this.setDrillDownValue(event, question, this, -1);
                }
              }
            });
          }
        } else {
          question.AnswerText = null;
          this.setDrillDownValue(event, question, this, -1);
        }
      }
    }, 0);

    const target = event.target as HTMLInputElement;
    const td = target.closest('td');
    if (td) {
      (td as HTMLElement).style.zIndex = '0';
    }

    setTimeout(() => {
      const messageElement = document.querySelector(
        `.drill-down-list-itemMessage_${question.UniqueNumber}`,
      );
      if (messageElement) {
        (messageElement as HTMLElement).style.display = 'none';
      }
    }, 1);
  }

  filterDDSearch(event: KeyboardEvent, question: Questions) {
    const keyCode = event.keyCode || event.which;
    if (keyCode === 13 || keyCode === undefined) {
      event.preventDefault();
      const target = event.target as HTMLInputElement;
      target.blur();
      setTimeout(() => {
        const drillSearch = target.closest('.drill-down-search');
        if (drillSearch) {
          drillSearch.classList.remove('showDrillList');
        }
      }, 100);
    }

    setTimeout(() => {
      const keyCode = event.keyCode || event.which;
      if (keyCode !== 9) {
        const target = event.target as HTMLInputElement;
        const drillSearch = target.closest('.drill-down-search');
        if (drillSearch) {
          drillSearch.classList.add('showDrillList');

          if (keyCode === 40) {
            event.preventDefault();
            const select = drillSearch.querySelector('select') as HTMLSelectElement;
            const visibleItems = Array.from(
              drillSearch.querySelectorAll('.drill-down-list-item:not([style*="display: none"])'),
            );
            const lastVisibleItem = visibleItems[visibleItems.length - 1];
            const firstVisibleItem = visibleItems[0];

            if (!select.value || select.value === lastVisibleItem.getAttribute('list-value')) {
              select.value = firstVisibleItem.getAttribute('list-value') || '';
              drillSearch
                .querySelector('.currentActiveDDITem')
                ?.classList.remove('currentActiveDDITem');
              firstVisibleItem.classList.add('currentActiveDDITem');
              target.value = select.options[select.selectedIndex].text;
            } else {
              const currentActive = drillSearch.querySelector('.currentActiveDDITem');
              const nextElement = currentActive?.nextElementSibling;
              if (
                nextElement &&
                nextElement.classList.contains('drill-down-list-item') &&
                (nextElement as HTMLElement).style.display !== 'none'
              ) {
                select.value = nextElement.getAttribute('list-value') || '';
                target.value = select.options[select.selectedIndex].text;
                currentActive?.classList.remove('currentActiveDDITem');
                nextElement.classList.add('currentActiveDDITem');
              } else {
                if (currentActive) {
                  select.value = currentActive.getAttribute('list-value') || '';
                  target.value = select.options[select.selectedIndex].text;
                  currentActive.classList.remove('currentActiveDDITem');
                  currentActive.classList.add('currentActiveDDITem');
                }
              }
            }

            const currentActive = drillSearch.querySelector('.currentActiveDDITem');
            if (currentActive) {
              const elementPos = currentActive.getBoundingClientRect().top;
              const elementPosWithHt = elementPos + currentActive.getBoundingClientRect().height;
              const drillList = drillSearch.querySelector('.drill-down-list');
              if (drillList) {
                const scrollableDivPos = drillList.getBoundingClientRect().top;
                const scrollableDivPosWithHt =
                  scrollableDivPos + drillList.getBoundingClientRect().height;

                if (elementPosWithHt > scrollableDivPosWithHt) {
                  drillList.scrollTop += elementPosWithHt - scrollableDivPosWithHt;
                } else if (elementPos < scrollableDivPos) {
                  drillList.scrollTop -= scrollableDivPos - elementPos;
                }
              }
            }
          } else if (keyCode === 38) {
            event.preventDefault();
            const select = drillSearch.querySelector('select') as HTMLSelectElement;
            const visibleItems = Array.from(
              drillSearch.querySelectorAll('.drill-down-list-item:not([style*="display: none"])'),
            );
            const lastVisibleItem = visibleItems[visibleItems.length - 1];
            const firstVisibleItem = visibleItems[0];

            if (!select.value || select.value === firstVisibleItem.getAttribute('list-value')) {
              select.value = lastVisibleItem.getAttribute('list-value') || '';
              drillSearch
                .querySelector('.currentActiveDDITem')
                ?.classList.remove('currentActiveDDITem');
              lastVisibleItem.classList.add('currentActiveDDITem');
              target.value = select.options[select.selectedIndex].text;
            } else {
              const currentActive = drillSearch.querySelector('.currentActiveDDITem');
              const prevElement = currentActive?.previousElementSibling;
              if (
                prevElement &&
                prevElement.classList.contains('drill-down-list-item') &&
                (prevElement as HTMLElement).style.display !== 'none'
              ) {
                select.value = prevElement.getAttribute('list-value') || '';
                target.value = select.options[select.selectedIndex].text;
                currentActive?.classList.remove('currentActiveDDITem');
                prevElement.classList.add('currentActiveDDITem');
              } else {
                if (currentActive) {
                  select.value = currentActive.getAttribute('list-value') || '';
                  target.value = select.options[select.selectedIndex].text;
                  currentActive.classList.remove('currentActiveDDITem');
                  currentActive.classList.add('currentActiveDDITem');
                }
              }
            }

            const currentActive = drillSearch.querySelector('.currentActiveDDITem');
            if (currentActive) {
              const elementPos = currentActive.getBoundingClientRect().top;
              const elementPosWithHt = elementPos + currentActive.getBoundingClientRect().height;
              const drillList = drillSearch.querySelector('.drill-down-list');
              if (drillList) {
                const scrollableDivPos = drillList.getBoundingClientRect().top;
                const scrollableDivPosWithHt =
                  scrollableDivPos + drillList.getBoundingClientRect().height;

                if (elementPosWithHt > scrollableDivPosWithHt) {
                  drillList.scrollTop += elementPosWithHt - scrollableDivPosWithHt;
                } else if (elementPos < scrollableDivPos) {
                  drillList.scrollTop -= scrollableDivPos - elementPos;
                }
              }
            }
          } else {
            const td = target.closest('td');
            if (td) {
              (td as HTMLElement).style.zIndex = '2';
            }
            drillSearch
              .querySelector('.currentActiveDDITem')
              ?.classList.remove('currentActiveDDITem');
            const select = drillSearch.querySelector('select') as HTMLSelectElement;
            select.value = '-1';
            const ddSearchValue = target.value.toLowerCase();

            if (ddSearchValue !== '') {
              let isShowmessage = false;
              const listItems = drillSearch.querySelectorAll('.drill-down-list-item');
              listItems.forEach((item) => {
                const originalValue = item.getAttribute('ogListValue');
                if (originalValue) {
                  item.innerHTML = originalValue;
                  if (item.textContent?.toLowerCase().includes(ddSearchValue)) {
                    (item as HTMLElement).style.display = 'block';
                    item.innerHTML = this.highlight(item.innerHTML, ddSearchValue);
                    isShowmessage = true;
                  } else {
                    (item as HTMLElement).style.display = 'none';
                  }
                }
              });

              const messageElement = document.querySelector(
                `.drill-down-list-itemMessage_${question.UniqueNumber}`,
              );
              if (messageElement) {
                (messageElement as HTMLElement).style.display = isShowmessage ? 'none' : 'block';
              }

              const visibleItems = drillSearch.querySelectorAll(
                '.drill-down-list-item:not([style*="display: none"])',
              );
              if (visibleItems.length === 0) {
                drillSearch.classList.remove('showDrillList');
                if (td) {
                  (td as HTMLElement).style.zIndex = '0';
                }
              } else {
                drillSearch.classList.add('showDrillList');
                if (td) {
                  (td as HTMLElement).style.zIndex = '2';
                }
              }
            } else {
              const messageElement = document.querySelector(
                `.drill-down-list-itemMessage_${question.UniqueNumber}`,
              );
              if (messageElement) {
                (messageElement as HTMLElement).style.display = 'none';
              }
              const listItems = drillSearch.querySelectorAll('.drill-down-list-item');
              listItems.forEach((item) => {
                (item as HTMLElement).style.display = 'block';
                const originalValue = item.getAttribute('ogListValue');
                if (originalValue) {
                  item.innerHTML = originalValue;
                }
              });
            }

            if (target.value !== this.prevValue) {
              this.checkDrillDown = 0;
            } else {
              this.checkDrillDown = 1;
            }
          }
        }
      }
    }, 1);
  }

  setPrevValue(event) {
    this.prevValue = event.target.value;
  }
  highlight(s, search) {
    return s.replace(
      new RegExp(search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), 'gi'),
      '<b>$&</b>',
    );
  }

  setRddColWidth() {
    const elemid = `#dv_${this.firstQuestion?.UniqueNumber}`;
    const element = this.getElement(elemid.replace('#', ''));
    if (element) {
      const fieldsetWrapper = element.querySelector('.fieldset-wrapper');
      if (fieldsetWrapper) {
        const fieldWidth = (fieldsetWrapper as HTMLElement).offsetWidth;

        this.mainQuestionWidth = this.matrix.subq_col_width;
        this.mainQuestionWidth = fieldWidth * (this.mainQuestionWidth / 100);
        this.subQuestionWidth = this.group.colwidth;
        this.subQuestionWidth = fieldWidth * (this.subQuestionWidth / 100) - 25;
        this.totalWidth = this.mainQuestionWidth + this.subQuestionWidth;

        if (this.mainQuestionWidth == 0) {
          this.mainQuestionWidth = fieldWidth / 2;
        }

        if (this.subQuestionWidth == 0) {
          this.subQuestionWidth = fieldWidth / 2 - 30;
        }

        if (this.totalWidth === 0) {
          this.totalWidth = fieldWidth;
        }

        const matrixTitleTd = element.querySelector('.matrixTitleTd');
        if (matrixTitleTd) {
          (matrixTitleTd as HTMLElement).style.width = `${this.mainQuestionWidth - 30}px`;
        }
        this.changeDetect.detectChanges();
      }
    }
  }

  nextQuestion(event) {
    if (
      this.isNewParticipation &&
      (this.surveyFormat == 1 || this.surveyFormat == 2) &&
      this.dropDownlength == 1 &&
      this.service.isAutoScroll
    ) {
      this.service.gotoNextQuestion(this.questions[0], event);
    }
  }

  gotoNextQuestion(question: Questions, event: any) {
    this.service.gotoNextQuestion(question, event);
  }

  gotoNextQuestionKeyboard(question, event) {
    event.preventDefault();
    this.gotoNextQuestion(question, event.target);
  }

  ngAfterHandle() {
    this.ngCount = 0;
    this.ngAfterViewInit();
  }

  getAnswerPipeMessage(): string {
    return this.service.getAnswerPipeMessage();
  }

  isQuestionsPostPopulated(question: Questions): boolean {
    if (
      (question.population_type == 4 || question.population_type == 5) &&
      this.service.getisEditPostPop()
    ) {
      return true;
    }
    return false;
  }

  isPostEditDisable(question: Questions): boolean {
    if (
      this.service.getisEditPostPop() &&
      question.population_type != 4 &&
      question.population_type != 5
    ) {
      return true;
    }
    return false;
  }
}
